// ===============================================================================

/**
* All filter ids.
*/
export enum FilterId {
    MyCustomerSearch = "MyCustomerSearch",
    HasActiveRequests = "HasActiveRequests",
    SharedMaterialsSearch = "SharedMaterialsSearch",
    Category = "Category",
    Sds = "Sds",
    SupplierId = "SupplierId",
    MyCustomerRequestsSearch = "MyCustomerRequestsSearch",
    SharedMaterialsCompliance = "SharedMaterialsCompliance"
}

// ===============================================================================

/**
* Standard filters.
*/

export interface Filter {
    value: string;
    filterId: FilterId | string;
    filterParameter: string | null;
}
